import useSWR from 'swr';

export type CryptoRelatedMarketNumber = number | string | null;

export interface CryptoRelatedMarketOutcome {
  market_id: string;
  market_slug?: string | null;
  market_question: string;
  category?: string | null;
  outcome_yes: string;
  outcome_no: string;
  outcome_yes_price: CryptoRelatedMarketNumber;
  outcome_no_price: CryptoRelatedMarketNumber;
  market_active: string | number;
  market_closed: string | number;
  end_date?: string | null;
  closed_time?: string | null;
  group_item_title?: string;
  price_change_24h?: CryptoRelatedMarketNumber;
  recommendation?: string;
  market_image?: string | null;
  market_icon?: string | null;
  total_volume_usdc?: CryptoRelatedMarketNumber;
  last_trade_price?: CryptoRelatedMarketNumber;
  created_at?: string | null;
  data_updated_at?: string | null;
}

export interface CryptoRelatedMarketEvent {
  id: string;
  slug: string;
  event_id: string;
  title: string;
  image: string;
  icon: string;
  category: string | null;
  description: string | null;
  ticker: string | null;
  cover: string | null;
  total_volume: CryptoRelatedMarketNumber;
  total_liquidity: CryptoRelatedMarketNumber;
  end_date: string | null;
  closed_time: string | null;
  closed: number | null;
  active: number | null;
  volume_24hr: CryptoRelatedMarketNumber;
  markets: CryptoRelatedMarketOutcome[];
  recommended_questions: string[];
  time_category?: string;
}

export interface CryptoRelatedMarketResponse {
  symbol: string;
  markets: CryptoRelatedMarketEvent[];
  limit: number;
  offset: number;
}

export function useCryptoRelatedMarket(symbol: string) {
  return useSWR<CryptoRelatedMarketResponse>(`api:/market/crypto/${symbol}/relate-market`);
}
